// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar{
    display:none;
    max-width:90%;
    position:absolute;
    background:white;
    border-radius:16px;
    padding:25px;
    height:fit-content;
    box-shadow:0 4px 15px rgba(0,0,0,.08);
    z-index:10;
    left: 50%;
    transform: translate(-50%, 0%);
}

.sidebar.show {
    display:block;
}

.sidebar h3{
    margin-bottom:20px;
}

.sidebar-btn{
    position:absolute;
    display:block;
    text-align:center;
    text-decoration:none;
    background:#0f172a;
    color:white;
    padding:14px;
    border-radius:50%;
    font-weight:600;
    transition:.3s;
    top: 16px;
    right: 16px;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.3), 0 8px 16px -6px rgba(0, 0, 0, 0.3);
}

.filter-group{
    margin-bottom:30px;
}

.filter-group h4{
    margin-bottom:12px;
    color:#dc2626;
}

.filter-group label{
    display:block;
    margin:10px 0;
    cursor:pointer;
    color:#475569;
}

@media(min-width:900px){
  .sidebar{
    display:block;
    position:relative;
    width:280px;
    background:white;
    border-radius:16px;
    padding:25px;
    height:fit-content;
    box-shadow:0 4px 15px rgba(0,0,0,.08);
    left: 0%;
    transform: translate(0%, 0%);
  }
  .sidebar-btn{
    display:none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Listing/css/ListingFilters.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,UAAU;IACV,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,SAAS;IACT,WAAW;IACX,mFAAmF;AACvF;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,cAAc;IACd,aAAa;AACjB;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,QAAQ;IACR,4BAA4B;EAC9B;EACA;IACE,YAAY;EACd;AACF","sourcesContent":[".sidebar{\r\n    display:none;\r\n    max-width:90%;\r\n    position:absolute;\r\n    background:white;\r\n    border-radius:16px;\r\n    padding:25px;\r\n    height:fit-content;\r\n    box-shadow:0 4px 15px rgba(0,0,0,.08);\r\n    z-index:10;\r\n    left: 50%;\r\n    transform: translate(-50%, 0%);\r\n}\r\n\r\n.sidebar.show {\r\n    display:block;\r\n}\r\n\r\n.sidebar h3{\r\n    margin-bottom:20px;\r\n}\r\n\r\n.sidebar-btn{\r\n    position:absolute;\r\n    display:block;\r\n    text-align:center;\r\n    text-decoration:none;\r\n    background:#0f172a;\r\n    color:white;\r\n    padding:14px;\r\n    border-radius:50%;\r\n    font-weight:600;\r\n    transition:.3s;\r\n    top: 16px;\r\n    right: 16px;\r\n    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.3), 0 8px 16px -6px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.filter-group{\r\n    margin-bottom:30px;\r\n}\r\n\r\n.filter-group h4{\r\n    margin-bottom:12px;\r\n    color:#dc2626;\r\n}\r\n\r\n.filter-group label{\r\n    display:block;\r\n    margin:10px 0;\r\n    cursor:pointer;\r\n    color:#475569;\r\n}\r\n\r\n@media(min-width:900px){\r\n  .sidebar{\r\n    display:block;\r\n    position:relative;\r\n    width:280px;\r\n    background:white;\r\n    border-radius:16px;\r\n    padding:25px;\r\n    height:fit-content;\r\n    box-shadow:0 4px 15px rgba(0,0,0,.08);\r\n    left: 0%;\r\n    transform: translate(0%, 0%);\r\n  }\r\n  .sidebar-btn{\r\n    display:none;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
